import { useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import ProtectedRoute from "./common/ProtectedRoute"; 
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";

import UserAccounts from "./scenes/useraccounts";
import Subscriptions from "./scenes/subscriptions";

import Landing from "./pages/landing";
import Login from "./pages/login";
import Logout from "./pages/logout";
import Reset from "./pages/reset";
import Signup from "./pages/signup";
import ContactUs from "./pages/contactus";
import Subscribe from "./pages/subscribe";
import Pricing from "./pages/pricing";
import CheckoutSuccess from "./pages/subscribe/steps/checkoutsuccess";
import CheckoutCancelled from "./pages/subscribe/steps/checkoutcancel";
import CheckoutSuccessDodo from "./pages/subscribe/steps/checkoutsuccessdodo";
import CheckoutCancelledDodo from "./pages/subscribe/steps/checkoutcanceldodo";

import ConfirmMarketingOptIn from "./pages/confirmmarketingoptin";

import PaidMarketingLandingPage from "./pages/paidmarketinglandingpage";

import PaidMarketingLandingPageReddit from "./pages/paidmarketinglandingpagereddit";

import  OptOutOfMarketingEmails from "./pages/optoutmarketingemails";

import  OptOutOfPPCMarketingEmails from "./pages/optoutppcmarketingemails";

import  DemoPage from "./pages/demopage";

import TermsOfService from "./pages/termsofservice";

import Dashboard from "./scenes/dashboard";

import Unauthorized from "./scenes/unauthorized";

import NotFound from "./pages/pagenotfound";

import CharitableCauses from "./scenes/charitablecauses";
import Volunteers from "./scenes/volunteers";
import Donors from "./scenes/donors";
import Events from "./scenes/events";
import Donations from "./scenes/donations";
import DonationsByStatus from "./scenes/donations/indexByStatus";
import DonationsByPaymentMethod from "./scenes/donations/indexByPaymentMethod";
import FundraisingPages from "./scenes/fundraisingpages";
import FundraisingPagesByCampaignStatus from "./scenes/fundraisingpages/indexByCampaignStatus";
import GrantManagement from "./scenes/grantmanagement";
import GrantManagementByStatus from "./scenes/grantmanagement/indexByStatus";
import Partnerships from "./scenes/partnerships";
import PartnershipsByPartnershipType from "./scenes/partnerships/indexByPartnershipType";
import BeneficiaryManagement from "./scenes/beneficiarymanagement";
import BeneficiaryManagementByGender from "./scenes/beneficiarymanagement/indexByGender";
import CorporateGiving from "./scenes/corporategiving";
import CorporateGivingByPaymentMethod from "./scenes/corporategiving/indexByPaymentMethod";
import VolunteerRecognition from "./scenes/volunteerrecognition";
import VolunteerRecognitionByRecognitionType from "./scenes/volunteerrecognition/indexByRecognitionType";


import ToastMessageDisplay from "./common/ToastMessageDisplay"; 
import { UserProvider } from "./common/UserContext";
import { ApplicationModeProvider } from "./common/ApplicationModeContext";
import { UserCountProvider } from "./common/UserCountContext";
import { AccountProvider } from "./common/AccountContext";

import Bar from "./scenes/bar";
import Line from "./scenes/line";
import Pie from "./scenes/pie";
import Geography from "./scenes/geography";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import Calendar from "./scenes/calendar/calendar";
import { Navigate } from "react-router-dom";

function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");  // Add this line to hold the search term
  const location = useLocation();

  const publicPaths = ["/", 
    "/index.html", 
    "/login", 
    "/logout", 
    "/reset", 
    "/signup",
    "/contactus", 
    "/subscribe", 
    "/pricing", 
    "/terms-of-service", 
    "/confirm-marketing-opt-in",
    "/opt-out-of-marketing-emails",
    "/opt-out-of-ppc-marketing-emails",
    "/checkout-success", 
    "/checkout-cancelled",
    "/checkout-dodo-success", 
    "/checkout-dodo-cancelled",

    "/not-found",
    "/limited-time-discount-offer",
    "/demo",
    "/i-built-a-tool"];

  const isPublic = publicPaths.includes(location.pathname);

/************************************ PUBLIC PAGES ********************************************* */

if (isPublic) {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/index.html" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/logout" element={<Logout />} />
      <Route path="/reset" element={<Reset />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/contactus" element={<ContactUs />} />
      <Route path="/subscribe" element={<Subscribe />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/confirm-marketing-opt-in" element={<ConfirmMarketingOptIn />} />
      <Route path="/opt-out-of-marketing-emails" element={<OptOutOfMarketingEmails />} />
      <Route path="/opt-out-of-ppc-marketing-emails" element={<OptOutOfPPCMarketingEmails />} />
      <Route path="/limited-time-discount-offer" element={<PaidMarketingLandingPage />} />
      <Route path="/i-built-a-tool" element={<PaidMarketingLandingPageReddit />} />
      <Route path="/demo" element={<DemoPage />} />

      <Route path="/checkout-success" element={<CheckoutSuccess />} />
      <Route path="/checkout-cancelled" element={<CheckoutCancelled />} />
      <Route path="/checkout-dodo-success" element={<CheckoutSuccessDodo />} />
      <Route path="/checkout-dodo-cancelled" element={<CheckoutCancelledDodo />} />

      <Route path="/not-found" element={<NotFound />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

/************************************ PRIVATE PAGES ********************************************* */

  return (
    <ApplicationModeProvider>  
      <UserProvider>
        <UserCountProvider>
          <AccountProvider>
            <ColorModeContext.Provider value={colorMode}>
              <ThemeProvider theme={theme}>
                <CssBaseline />
                <div className="app">
                  <Sidebar isSidebar={isSidebar} />
                  <main className="content">
                    <Topbar setIsSidebar={setIsSidebar} searchTerm={searchTerm} setSearchTerm={setSearchTerm}/>
                    <Routes>
                      <Route path="/app" element={<ProtectedRoute element={<Dashboard />} />} />

                      <Route path="/charitablecauses" element={<ProtectedRoute element={<CharitableCauses searchTerm={searchTerm} />} />} />
<Route path="/volunteers" element={<ProtectedRoute element={<Volunteers searchTerm={searchTerm} />} />} />
<Route path="/donors" element={<ProtectedRoute element={<Donors searchTerm={searchTerm} />} />} />
<Route path="/events" element={<ProtectedRoute element={<Events searchTerm={searchTerm} />} />} />
<Route path="/events/list" element={<ProtectedRoute element={<Events searchTerm={searchTerm} />} />} />
<Route path="/donations" element={<ProtectedRoute element={<Donations searchTerm={searchTerm} />} />} />
<Route path="/donations/list" element={<ProtectedRoute element={<Donations searchTerm={searchTerm} />} />} />
<Route path="/donations/status" element={<ProtectedRoute element={<DonationsByStatus searchTerm={searchTerm} />} />} />
<Route path="/donations/paymentmethod" element={<ProtectedRoute element={<DonationsByPaymentMethod searchTerm={searchTerm} />} />} />
<Route path="/fundraisingpages" element={<ProtectedRoute element={<FundraisingPages searchTerm={searchTerm} />} />} />
<Route path="/fundraisingpages/list" element={<ProtectedRoute element={<FundraisingPages searchTerm={searchTerm} />} />} />
<Route path="/fundraisingpages/campaignstatus" element={<ProtectedRoute element={<FundraisingPagesByCampaignStatus searchTerm={searchTerm} />} />} />
<Route path="/grantmanagement" element={<ProtectedRoute element={<GrantManagement searchTerm={searchTerm} />} />} />
<Route path="/grantmanagement/list" element={<ProtectedRoute element={<GrantManagement searchTerm={searchTerm} />} />} />
<Route path="/grantmanagement/status" element={<ProtectedRoute element={<GrantManagementByStatus searchTerm={searchTerm} />} />} />
<Route path="/partnerships" element={<ProtectedRoute element={<Partnerships searchTerm={searchTerm} />} />} />
<Route path="/partnerships/list" element={<ProtectedRoute element={<Partnerships searchTerm={searchTerm} />} />} />
<Route path="/partnerships/partnershiptype" element={<ProtectedRoute element={<PartnershipsByPartnershipType searchTerm={searchTerm} />} />} />
<Route path="/beneficiarymanagement" element={<ProtectedRoute element={<BeneficiaryManagement searchTerm={searchTerm} />} />} />
<Route path="/beneficiarymanagement/list" element={<ProtectedRoute element={<BeneficiaryManagement searchTerm={searchTerm} />} />} />
<Route path="/beneficiarymanagement/gender" element={<ProtectedRoute element={<BeneficiaryManagementByGender searchTerm={searchTerm} />} />} />
<Route path="/corporategiving" element={<ProtectedRoute element={<CorporateGiving searchTerm={searchTerm} />} />} />
<Route path="/corporategiving/list" element={<ProtectedRoute element={<CorporateGiving searchTerm={searchTerm} />} />} />
<Route path="/corporategiving/paymentmethod" element={<ProtectedRoute element={<CorporateGivingByPaymentMethod searchTerm={searchTerm} />} />} />
<Route path="/volunteerrecognition" element={<ProtectedRoute element={<VolunteerRecognition searchTerm={searchTerm} />} />} />
<Route path="/volunteerrecognition/list" element={<ProtectedRoute element={<VolunteerRecognition searchTerm={searchTerm} />} />} />
<Route path="/volunteerrecognition/recognitiontype" element={<ProtectedRoute element={<VolunteerRecognitionByRecognitionType searchTerm={searchTerm} />} />} />


                      <Route path="/pie" element={<ProtectedRoute element={<Pie />} />} />
                      <Route path="/line" element={<ProtectedRoute element={<Line />} />} />
                      <Route path="/calendar" element={<ProtectedRoute element={<Calendar />} />} />
                      <Route path="/geography" element={<ProtectedRoute element={<Geography />} />} />

                      <Route path="/useraccounts" element={<ProtectedRoute element={<UserAccounts />} role="admin" />} />
                      <Route path="/subscriptions" element={<ProtectedRoute element={<Subscriptions />} role="admin" />} />

                      <Route path="/unauthorized" element={<ProtectedRoute element={<Unauthorized />} />} />

                      <Route path="*" element={<Navigate to="/not-found" replace />} />

                    </Routes>
                    <ToastMessageDisplay />
                  </main>
                </div>
              </ThemeProvider>
            </ColorModeContext.Provider>
            </AccountProvider>
        </UserCountProvider>
      </UserProvider>
    </ApplicationModeProvider>
  );
}

export default App;
